import { DataTableArgs } from 'src/components/DataTable/DataTable.types'
import { useState } from 'react'

export const usePagination = () => {
    return useState<DataTableArgs>({
        page: 0,
        size: 10,
    })
}